export enum SEARCH_TYPE {
  MEDICINE = 'Receita médica',
  FORMULA = 'Fórmulas',
  EXAMS = 'Exames e Cirurgias',
  EXAMS_ONLY = 'Exames',
  MEDICAL_CERTIFICATE = 'Atestado',
  MEDICAL_REPORT = 'Relatório',
  MEDICAL_REFERRAL = 'Encaminhamento',
}

export enum SEARCH_TYPE_EXAM_LABEL {
  MEDICINE = 'Receita médica',
  FORMULA = 'Fórmulas',
  EXAMS = 'Exames',
  MEDICAL_CERTIFICATE = 'Atestado',
  MEDICAL_REPORT = 'Relatório',
  MEDICAL_REFERRAL = 'Encaminhamento',
}

export enum SEARCH_TYPE_MAP {
  'Receita médica' = 'MEDICINE',
  'Fórmulas' = 'FORMULA',
  'Exames e Cirurgias' = 'EXAMS',
  'Exames' = 'EXAMS',
  'Atestado' = 'MEDICAL_CERTIFICATE',
  'Relatório' = 'MEDICAL_REPORT',
  'Encaminhamento' = 'MEDICAL_REFERRAL',
}
